import React from "react";

const Terms = () => {
  return (
    <div className="px-4 mx-lg-5 px-lg-5">
      <div className="px-lg-3">
        <h3 className="text-center  pb-4 pt-3">
          *Terms and Conditions for The Elite Enterprise E-commerce Website*
        </h3>
        <p>
          <h6 className="fw-bold"> *1. Acceptance of Terms:*</h6> By using and
          accessing the services provided by The Elite Enterprise website, you
          agree to abide by these terms and conditions. If you do not agree with
          any part of these terms, kindly refrain from using our services.
        </p>
        <p>
          <h6 className="fw-bold">*2. Product Information:* </h6>We strive to
          provide accurate and up-to-date product information. However, The
          Elite Enterprise is not responsible for any inaccuracies or
          discrepancies in product descriptions, images, or prices. For
          clarifications, contact us at &nbsp;
          <span className="fw-bold">info@theeliteenterprise.in</span>
          &nbsp; or &nbsp; <span className="fw-bold">+91 98202 44338.</span>
        </p>
        <p>
          <h6 className="fw-bold">*3. Order Confirmation:*</h6> Once an order is
          placed, you will receive an order confirmation via email. This
          confirmation serves as acknowledgment of your purchase details. In
          case of any discrepancies, promptly contact us.
        </p>
        <p>
          <h6 className="fw-bold"> *4. Payment:*</h6> All transactions on our
          website are secured. The Elite Enterprise accepts payments through
          various methods, ensuring a safe and convenient shopping experience.
          For any payment-related concerns, contact our support team.
        </p>
        <p>
          <h6 className="fw-bold"> *5. Shipping and Delivery:*</h6> We strive to
          ensure timely delivery; however, delivery times may vary. The Elite
          Enterprise is not liable for any delays or issues caused by external
          factors. For delivery-related queries, please contact our customer
          support.
        </p>
        <p>
          <h6 className="fw-bold"> *6. Returns and Refunds:*</h6> Refer to our
          Return Policy for detailed information on returns and refunds. Contact
          our support team at &nbsp;
          <span className="fw-bold">info@theeliteenterprise.in</span> &nbsp; or
          &nbsp;
          <span className="fw-bold">+91 98202 44338</span> for assistance.
        </p>
        <p>
          <h6 className="fw-bold"> *7. User Accounts:*</h6> Users are
          responsible for maintaining the confidentiality of their account
          credentials. The Elite Enterprise is not liable for any unauthorized
          access or activities on user accounts. Report any suspicious
          activities immediately.
        </p>
        <p>
          <h6 className="fw-bold"> *8. Privacy Policy:* </h6>The Elite
          Enterprise is committed to safeguarding your privacy. Our Privacy
          Policy outlines how we collect, use, and protect your personal
          information. By using our services, you agree to our Privacy Policy.
        </p>
        <p>
          <h6 className="fw-bold"> *9. Communication:* </h6>By providing your
          contact details, including email and phone number, you consent to
          receive communications from The Elite Enterprise, including
          promotional materials and updates. You can opt out of these
          communications at any time.
        </p>
        <h6 className="fw-bold"> *10. Governing Law:*</h6> These terms and
        conditions are governed by and construed in accordance with the laws of
        [Your Jurisdiction]. Any disputes arising from the use of our services
        will be subject to the exclusive jurisdiction of the courts in [Your
        Jurisdiction].
        <h6 className="fw-bold pt-3">*Contact Information:*</h6>
        <p>
          <span className="fw-bold">- Email:</span>info@theeliteenterprise.in
        </p>
        <p>
          <span className="fw-bold">- Phone: </span>+91 98202 44338
        </p>
        For any inquiries or clarifications regarding these terms and
        conditions, please contact us using the provided contact information.
        The Elite Enterprise reserves the right to update or modify these terms
        at any time without prior notice. Please review these terms periodically
        for any changes.
      </div>
    </div>
  );
};

export default Terms;
